<div class="d-flex justify-content-between align-items-center" *ngIf="showLabel">
  <span class="info-label">{{'customer.bonusBalance' | translate}}</span>
  <h4> <span class="badge rounded" [ngClass]="{'bg-success':balance>0,
  'bg-danger':balance<0,'bg-info':balance==0}">
      {{ balance | thousandSeparatorWithDecimals}}
    </span>
  </h4>
</div>
<div *ngIf="!showLabel">
  <h4> <span class="badge rounded text-end" [ngClass]="{'bg-success':balance>0,
  'bg-danger':balance<0,'bg-info':balance==0}">
      {{ balance | thousandSeparatorWithDecimals}}
    </span>
  </h4>
</div>